module.exports = __webpack_public_path__ + "static/media/Up.aa1dfe7d.svg";